/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { Label, RadioButton } from '@gsa/afp-component-library';
import { Controller, useFormContext } from 'react-hook-form';

const BidSelection = () => {
  const { control } = useFormContext();

  return (
    <div>
      <Label required>Bid selection</Label>
      <Controller
        control={control}
        name="bidType"
        defaultValue="OUTSIDE_FLEET"
        render={({ field }) => (
          <>
            {/* not implemented yet, will be enabled once the requirement is done */}
            <RadioButton
              label="Bid in GSA Fleet"
              name="bidType"
              value="IN_FLEET"
              disabled
              checked={field.value === 'IN_FLEET'}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
            <div className="radio-group">
              <RadioButton
                label="External Bid"
                name="bidType"
                value="OUTSIDE_FLEET"
                checked={field.value === 'OUTSIDE_FLEET'}
                onChange={(e) => {
                  field.onChange(e.target.value);
                }}
              />
              <p className="margin-left-4 margin-top-neg-1 text-base">
                The bid will be conducted outside of this system.
              </p>
            </div>
          </>
        )}
      />
    </div>
  );
};

export default BidSelection;
